import useMediaQuery from "@mui/material/useMediaQuery";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import LogoutIcon from "@mui/icons-material/Logout";

import toast from "react-hot-toast";
import Joi from "joi";

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./addStats.scss";

// redux
import { useDispatch, useSelector } from "react-redux";
import {
  addStats,
} from "../../../../../../store/reducers/reducerUser";
import { CircularProgress } from "@mui/material";
import { checkClass } from "../../../../../tools/checkClass";
import SiteButton from "../../../../../ui/SiteButton";
import { useLang } from "../../../../../../i18n/LangContext";

const AddStats = () => {
  const dispatch = useDispatch();
  const { t } = useLang();
  const params = useParams();
  const responsive = useMediaQuery("(max-width:500px)");
  const user = useSelector((state) => state.reducerUser.userLogin);
  const navigate = useNavigate();

  const [state, setState] = useState({
    username: user.data.username,
    name: "",
    StrengthFront: "",
    DexterityFront: "",
    VitalityFront: "",
    EnergyFront: "",
    CommandFront: "",
  });

  function go() {
    return navigate("/players");
  }

  useEffect(() => {
    user.data.data[1].players.map((player, i) => {
      if (player.Name == params.id) {
        setState({
          ...state,
          name: player.Name,
        });
      }
    });
  }, [params]);

  const [formSend, setFormSend] = useState(false);
  const [loader, setLoader] = useState(false);

  const schema = {
    username: Joi.string().required(),
    name: Joi.string().required(),
    StrengthFront: Joi.string().min(0),
    DexterityFront: Joi.string().min(0),
    VitalityFront: Joi.string().min(0),
    EnergyFront: Joi.string().min(0),
    CommandFront: Joi.string().min(0),
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setLoader(true);
    setFormSend(true);

    if (
      !state.StrengthFront &&
      !state.DexterityFront &&
      !state.VitalityFront &&
      !state.EnergyFront &&
      !state.CommandFront
    ) {
      setLoader(false);
      setFormSend(false);
      return toast.error("Invalid Points to add");
    }

    try {
      const { error } = Joi.object({ ...schema }).validate(state, {
        abortEarly: false,
      });

      if (error) {
        setLoader(false);
        for (const details of error.details) {
          setFormSend(false);
          return toast.error(details.message);
        }
      }

      dispatch(addStats(state)).then(function (response) {
        // console.log(response.payload.result);

        if (response.payload.result == "you cant add points over 32767") {
          // setCreditsSend("");
          // setReceiverUsername("");
          setLoader(false);
          setFormSend(false);
          return toast.error(response.payload.result);
        }

        if (
          response.payload.result ==
          "to add points you must logout from the game"
        ) {
          // setCreditsSend("");
          // setReceiverUsername("");
          setLoader(false);
          setFormSend(false);
          return toast.error(response.payload.result);
        }

        if (response.payload.result == "You do not have enough points to up") {
          // setCreditsSend("");
          // setReceiverUsername("")
          setLoader(false);
          setFormSend(false);
          return toast.error(response.payload.result);
        }

        setState({
          ...state,
          StrengthFront: "",
          DexterityFront: "",
          VitalityFront: "",
          EnergyFront: "",
          CommandFront: "",
        });
        setFormSend(false);
        setLoader(false);
        toast.success("Points add Successfully");
      });
    } catch (error) {
      if (error) {
        setLoader(false);
        return (
          toast.error("something wrong please send again"), setFormSend(false)
        );
      }
    }
  }

  const classes = useStyles();
  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      {user.data.data[1].players &&
        user.data.data[1].players.map((player, i) => {
          if (player.Name == params.id) {
            return (
              <div
                key={player.Name}
                className="containerAddStats"
                style={{
                  color: "white",
                  display: "flex",
                  flexFlow: "column",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    width: "100%",

                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <LogoutIcon
                    className="newCursor"
                    onClick={() => go()}
                    sx={{
                      color: "#AB9784",
                      height: "30px",
                      width: "30px",
                      cursor: "pointer",
                      // display: "flex",
                      // justifyContent: "right",
                    }}
                  />
                </div>
                <div>
                  <div>
                    <div className="addStatsPlayerName">
                      <img
                        className="playerImgAddStats"
                        src={checkClass(player.Class)}
                      />
                      <h2>{player.Name}</h2>
                      <h5>
                        <div>
                          {t("points")}: {player.LevelUpPoint}
                        </div>
                      </h5>
                    </div>
                    <hr />

                    <div>
                      <div>
                        <div className="titleStatsPlayer">
                          <strong>[{player.Strength}]</strong> ({t("strength")}):
                        </div>
                        <div>
                          <TextField
                            sx={{
                              marginBottom: "15px",
                              width: !responsive ? "40%" : "70%",
                            }}
                            className={classes.root}
                            size="small"
                            id="outlined-multiline-flexible"
                            label={t("strength")}
                            value={state.StrengthFront}
                            type="number"
                            name="StrengthFront"
                            onChange={(e) =>
                              setState({
                                ...state,
                                [e.target.name]:
                                  e.target.value < 1 ? 0 : e.target.value,
                              })
                            }
                            // onChange={(e) => setStrength(e.target.value)}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="titleStatsPlayer">
                          <strong>[{player.Dexterity}]</strong>
                          ({t("dexterity")}):
                        </div>
                        <div>
                          <TextField
                            sx={{
                              marginBottom: "15px",
                              width: !responsive ? "40%" : "70%",
                            }}
                            className={classes.root}
                            size="small"
                            id="outlined-multiline-flexible"
                            label={t("dexterity")}
                            value={state.DexterityFront}
                            type="number"
                            name="DexterityFront"
                            onChange={(e) =>
                              setState({
                                ...state,
                                [e.target.name]:
                                  e.target.value < 1 ? 0 : e.target.value,
                              })
                            }

                            // onChange={(e) => setDexterity(e.target.value)}
                          />
                        </div>
                      </div>{" "}
                      <div>
                        <div className="titleStatsPlayer">
                          <strong>[{player.Vitality}]</strong>
                          ({t("vitality")}):
                        </div>
                        <div>
                          <TextField
                            sx={{
                              marginBottom: "15px",
                              width: !responsive ? "40%" : "70%",
                            }}
                            className={classes.root}
                            size="small"
                            id="outlined-multiline-flexible"
                            label={t("vitality")}
                            value={state.VitalityFront}
                            type="number"
                            // onChange={(e) => setVitality(e.target.value)}
                            name="VitalityFront"
                            onChange={(e) =>
                              setState({
                                ...state,
                                [e.target.name]:
                                  e.target.value < 1 ? 0 : e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      <div>
                        <div className="titleStatsPlayer">
                          <strong> [{player.Energy}]</strong>
                          ({t("energy")}):
                        </div>
                        <div>
                          <TextField
                            sx={{
                              marginBottom: "15px",
                              width: !responsive ? "40%" : "70%",
                            }}
                            className={classes.root}
                            size="small"
                            id="outlined-multiline-flexible"
                            label={t("energy")}
                            value={state.EnergyFront}
                            type="number"
                            // onChange={(e) => setEnergy(e.target.value)}
                            name="EnergyFront"
                            onChange={(e) =>
                              setState({
                                ...state,
                                [e.target.name]:
                                  e.target.value < 1 ? 0 : e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                      {/* Command */}
                      {(player.Class == 64 || player.Class == 66) && (
                        <div>
                          <div className="titleStatsPlayer">
                            <strong> [{player.Leadership}]</strong>
                            ({t("command")}):
                          </div>
                          <div>
                            <TextField
                              sx={{
                                marginBottom: "15px",
                                width: !responsive ? "40%" : "70%",
                              }}
                              className={classes.root}
                              size="small"
                              id="outlined-multiline-flexible"
                              label={t("command")}
                              value={state.CommandFront}
                              type="number"
                              // onChange={(e) => setEnergy(e.target.value)}
                              name="CommandFront"
                              onChange={(e) =>
                                setState({
                                  ...state,
                                  [e.target.name]:
                                    e.target.value < 1 ? 0 : e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      )}
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                        >
                          {loader ? (
                            <CircularProgress className="loaderAddStats" />
                          ) : null}

                          <SiteButton
                            type="submit"
                            variant="primary"
                            className="buttonAddStats"
                            disabled={!!formSend}
                          >
                            {t("send")}
                          </SiteButton>

                          <div>{t("max_points")}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </form>
  );
};

const useStyles = makeStyles({
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-input": {
      color: "white",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiInputLabel-outlined": {
      color: "white",
    },
    "&:hover .MuiInputLabel-outlined": {
      color: "white",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "white",
    },
  },
});
export default AddStats;
